/**
 * Cloudinary delivery URL for a Peerspace image id (`img.peerspace.com`).
 */
const addOnImageUrl = (imageId: string): string =>
  `https://img.peerspace.com/image/upload/${imageId}.jpg`;

export { addOnImageUrl };
